import React, {useState, useEffect, useRef} from "react";
import { useLocation } from "react-router";
import { isPermission, isFeatureDisabled, yyyymmdd } from "../../../../Utils";
import Family from "../../../Authenticated/Components/Sidebar/icons/Family";
import { Shopping } from "../../../Authenticated/Components/Sidebar/icons/Shopping";
import QrCode from "./icons/QrCode";
import Chores from "./icons/Chores";
import {Timeline as TimelineIcon} from "../../../Authenticated/Components/Sidebar/icons/Timeline";
import Research from "../../../Authenticated/Components/Sidebar/icons/Research";
import Watchlist from "../../../Authenticated/Components/Sidebar/icons/Watchlist";
import Report from "../../../Authenticated/Components/Sidebar/icons/Report";
import InvestmentDashboard from "../../../Authenticated/Components/Sidebar/icons/InvestmentDashboard";
import GoalIcon from "./icons/Goals";
import Charities from "../../../Authenticated/Components/Sidebar/icons/Charities";
import { useTranslation } from "react-i18next";
import Menubar from "../../../Authenticated/Components/Sidebar/icons/Menubar";
import { CHILD_CHORES } from "../../../../Utils/constants";
import {Chores as ChoreIcon} from "../../../Authenticated/Components/Sidebar/icons/Chores";
import EducationIcon from "../../../Authenticated/Components/Sidebar/icons/EducationIcon";

const Bottom = (props) => {
  const { t } = useTranslation();
  const elementRef = useRef(null);
  const iconColor = props.state?.theme?.values?.tertiaryGrayColor;
  const location = useLocation();
  const isVisible = props.isMobileNav;
  const [themeLoaded,setthemeLoaded] = useState(false);
  const activeColor = props.state.theme.values.primaryWardColor;
  const defaultColor = props.state.theme.values.tertiaryGrayColor;
  const [choreCount, setChoreCount] = useState()

  useEffect(()=>{
    if(props && props.state && props.state.theme.values){
      setthemeLoaded(true);
    }
  },[props && props.state]);

  useEffect(() => {
   getChoresCount(); 
  }, [])

  useEffect(() => {
      if(window.innerWidth < 767 && window.location.pathname.includes('/child/')){
        const handleClickOutside = (event) => {
          setTimeout(() => {
            if(document.querySelector('.child-more-icons.dropdown')){
              if(document.querySelector('.child-more-icons.dropdown').classList.contains('show')){
                document.querySelector('body').classList.toggle('overflow-hidden');
                if(document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading')){
                  document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading').classList.toggle('no-background');
                }
              }
              else{
                document.querySelector('body').classList.remove('overflow-hidden');
                if(document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading')){
                  document.querySelector('.dashboard-wrapper .dashboard-right-article .dashboard-heading')?.classList.remove('no-background');
                }
                document.querySelector('.child-menu-toggle-items').classList.remove('show');
              }
            }
          }, 50);
        };
    
        document.addEventListener('mousedown', handleClickOutside);
    
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
      }
     
  }, [document.querySelector('.child-more-icons.dropdown.show')]);

  const getChoresCount = () => {
      props._list(CHILD_CHORES, null, (res) => {
        let amount = 0;
        let pending = 0;
  
        const now = new Date();
        res.forEach(e => {
          e.choreInstances.forEach(f => {
            const date = new Date(f.dueBy);
            if (yyyymmdd(date) === yyyymmdd(now)) {
              if (f.completionStatus === 0) {
                ++pending;
                amount = amount + e.amount;
              }
            }
          })
        })
  
        setChoreCount(pending)
      })
    }

  return (
    <>
      {props.investmentSidebar === false ?
        <div className={`bottom-navigation-bar ${isVisible ? '' : 'hide'}`}>
          <div className="inner-bar">
            <ul>
              <li onClick={() => props.history.push('/child/dashboard')} className={`${location.pathname === "/child/dashboard" ? 'active' : ''}`}>
                <span className="svgIcon">
                  <Family color={location.pathname === "/child/dashboard" ? activeColor : defaultColor} />
                </span>
                <span className="half-circle"></span>
              </li>
              {isFeatureDisabled(props,'Chores') === true && 
                <li onClick={() => props.history.push('/child/chores')} className={`${location.pathname === "/child/chores" ? 'active' : ''}`}>
                  <span className="svgIcon">
                    <ChoreIcon color={location.pathname === "/child/chores" ? activeColor : defaultColor} />
                  </span>
                  <span className="half-circle"></span>
                  {choreCount > 0 && <span className="badge">{choreCount}</span>}
                </li>
              }
              <li onClick={() => props.history.push('/child/goals')} className={`${location.pathname === "/child/goals" ? 'active' : ''}`}>
                <span className="svgIcon">
                  <GoalIcon color={location.pathname === "/child/goals" ? activeColor : defaultColor} />
                </span>
                <span className="half-circle"></span>
              </li>
              {isFeatureDisabled(props,'Education') === true &&
                <li onClick={() => props.history.push('/child/education')} className={`${location.pathname === "/child/education" ? 'active' : ''}`}>
                  <span className="svgIcon">
                    <EducationIcon color={location.pathname === "/child/education" ? activeColor : defaultColor} />
                  </span>
                  <span className="half-circle"></span>
                </li>
              }
              <div className={`child-more-icons dropdown ${(
                location.pathname === "/child/charities" ||
                location.pathname === "/child/settings" ||
                location.pathname === "/child/chores"
              ) ? 'active' : ''}`}>
                <div className="menu-toggler dropdown-toggle" id="child-more-menu-bottom" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  ref={elementRef}
                >
                  <Menubar color={(
                    location.pathname === "/child/charities" ||
                    location.pathname === "/child/settings" ||
                    location.pathname === "/child/chores"
                  ) ? activeColor : defaultColor}/>
                </div>
                <div className="child-menu-toggle-items menu-toggle-items dropdown-menu" aria-labelledby="child-more-menu-bottom">
                  <div className="menu-container">
                    <li onClick={() => props.history.push('/child/shopping')}>{t('shopping')}</li>
                    <li onClick={() => props.history.push('/child/charities')}>{t('charities')}</li>
                    <li onClick={() => props.history.push('/child/settings')}>{t('settings')}</li>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
        :

        <div className={`bottom-navigation-bar ${isVisible ? '' : 'hide'}`}>
          <div className="inner-bar">
            <ul>
              <li onClick={() => props.history.push('/child/investments/dashboard')} className={`${location.pathname === "/child/investments/dashboard" ? 'active' : ''}`}>
                <span className="svgIcon">
                  <InvestmentDashboard color={location.pathname === "/child/investments/dashboard" ? activeColor : defaultColor}/>
                </span>
                <span className="half-circle"></span>
              </li>
              <li onClick={() => props.history.push('/child/investments/timeline')} className={`${location.pathname === "/child/investments/timeline" ? 'active' : ''}`}>
                <span className="svgIcon">
                  <TimelineIcon color={location.pathname === "/child/investments/timeline" ? activeColor : defaultColor}/>
                </span>
                <span className="half-circle"></span>
              </li>
              <li onClick={() => props.history.push('/child/investments/research')} className={`${location.pathname === "/child/investments/research" ? 'active' : ''}`}>
                <span className="svgIcon">
                  <Research color={location.pathname === "/child/investments/research" ? activeColor : defaultColor}/>
                </span>
                <span className="half-circle"></span>
              </li>
              <li onClick={() => props.history.push('/child/investments/watchlist')} className={`${location.pathname === "/child/investments/watchlist" ? 'active' : ''}`}>
                <span className="svgIcon">
                  <Watchlist color={location.pathname === "/child/investments/watchlist" ? activeColor : defaultColor}/>
                </span>
                <span className="half-circle"></span>
              </li>
              <li onClick={() => props.history.push('/child/investments/reports')} className={` ${location.pathname === "/child/investments/reports" ? 'active' : ''}`}>
                <span className="svgIcon">
                  <Report color={location.pathname === "/child/investments/reports" ? activeColor : defaultColor}/>
                </span>
                <span className="half-circle"></span>
              </li>
            </ul>
          </div>
        </div>
      }
    </>
  );
};

export default Bottom;
